import React from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../../utils/authService';
import { defaultRouteFor } from './nav';

/**
 * Destino de /app: manda a cada rol a SU pantalla de inicio.
 *
 * Antes /app redirigía a /app/system-analytics para todos, así que una empresa o
 * un colaborador aterrizaban en una pantalla que no les corresponde y rebotaban
 * al login. Ahora: super admin → Analíticas, empresa → Panel, colaborador →
 * Portal del empleado.
 */
const RoleHome = () => {
  const role = authService?.getCurrentUser()?.role;
  return <Navigate to={defaultRouteFor(role)} replace />;
};

export default RoleHome;
